import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { VillageCreateForm } from "@/features/village/VillageCreateForm";

export function VillageCreate() {
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/subdistrict",
            label: "Sub District (Kel/Desa)",
          },
          {
            label: "Add",
          },
        ]}
      />
      <H2>Add Sub District (Kel/Desa)</H2>
      <VillageCreateForm />
    </>
  );
}
